const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export default function(date) {
    if (date == null) return ''
    if (typeof date === 'number')
        date = new Date(date)
    return months[date.getMonth()] + ' ' + date.getDate() + ' at ' + date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
}
